<div class="file-table-container">
  <p-toast />
  <h1 class="text-2xl font-bold heading"></h1>
  <p-table
    #dt
    *ngIf="country !== 'ie'"
    [value]="uploadedFiles"
    [(selection)]="selectedFiles"
    [sortField]="sortField"
    [sortOrder]="sortOrder"
    (onFilter)="onFilter($event)"
    dataKey="id"
    [rowHover]="true"
    [showCurrentPageReport]="true"
    [rowsPerPageOptions]="[10, 25, 50]"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
    [filterDelay]="0"
    [globalFilterFields]="[
      'name',
      'date',
      'source',
      'status',
      'repayment_count',
    ]"
    (onSort)="onTableSort($event)"
  >
    <ng-template #caption>
      <div class="flex justify-between items-center">
        <div class="caption-actions">
          <p-button
            [outlined]="true"
            icon="pi pi-filter-slash"
            label="Clear"
            (click)="clear(dt)"
          />
        </div>
        <p-iconField iconPosition="left">
          <p-inputIcon>
            <i class="pi pi-search"></i>
          </p-inputIcon>
          <input
            pInputText
            type="text"
            [(ngModel)]="searchValue"
            (input)="dt.filterGlobal($any($event.target).value, 'contains')"
            placeholder="Search"
          />
        </p-iconField>
      </div>
    </ng-template>
    <ng-template #header>
      <tr class="p-selectable-row">
        <th pSortableColumn="name" style="min-width: 2rem">
          <div class="flex justify-between items-center">
            Name
            <p-sortIcon field="name" />
            <p-columnFilter
              type="text"
              field="name"
              display="menu"
              class="ml-auto"
            />
          </div>
        </th>
        <th pSortableColumn="date" style="min-width: 2rem">
          <div class="flex justify-between items-center">
            Date
            <p-sortIcon field="date" />
            <p-columnFilter
              type="date"
              field="date"
              display="menu"
              class="ml-auto"
            />
          </div>
        </th>
        <th pSortableColumn="source" style="min-width: 2rem">
          <div class="flex justify-between items-center">
            Source
            <p-sortIcon field="source" />
            <p-columnFilter
              field="source"
              matchMode="equals"
              display="menu"
              [showMatchModes]="false"
              [showOperator]="false"
              [showAddButton]="false"
              class="ml-auto"
            >
              <ng-template
                pTemplate="filter"
                let-value
                let-filter="filterCallback"
              >
                <p-select
                  [options]="sourceOptions"
                  optionLabel="label"
                  optionValue="value"
                  [showClear]="true"
                  placeholder="Select source"
                  [ngModel]="value"
                  (onChange)="filter($event.value)"
                  styleClass="w-full"
                />
              </ng-template>
            </p-columnFilter>
          </div>
        </th>
        <th pSortableColumn="created_by" style="min-width: 2rem">
          <div class="flex justify-between items-center">
            Created By
            <p-sortIcon field="created_by" />
            <p-columnFilter
              type="text"
              field="created_by"
              display="menu"
              class="ml-auto"
            />
          </div>
        </th>
        <th pSortableColumn="repayment_count" style="min-width: 2rem">
          <div class="flex justify-between items-center">
            No. Records
            <p-sortIcon field="repayment_count" />
            <p-columnFilter
              type="text"
              field="repayment_count"
              display="menu"
              class="ml-auto"
            />
          </div>
        </th>
        <th pSortableColumn="status" style="min-width: 2rem">
          <div class="flex justify-between items-center">
            Status
            <p-sortIcon field="status" />
            <p-columnFilter
              type="text"
              field="status"
              display="menu"
              class="ml-auto"
            />
          </div>
        </th>
        <th style="width: 7rem"></th>
      </tr>
    </ng-template>
    <ng-template #body let-file let-ri="rowIndex">
      @if (!loading) {
        <uploaded-file-row #uploadedFileRow />
        <!-- Use row template and pass the buttons template in the context. -->
        <ng-container
          *ngTemplateOutlet="
            uploadedFileRow.row;
            context: {
              $implicit: file,
              buttonTemplate: buttonTemplate,
              onFileClick: onFileClick.bind(this),
              buttonTemplateContext: {
                $implicit: file,
                buttonHandler: this,
              },
            }
          "
        ></ng-container>
      } @else if (ri === 0) {
        <tr *ngFor="let _ of [1, 2, 3, 4, 5, 6, 7, 8]">
          <td *ngFor="let col of [1, 2, 3, 4, 5, 6, 7]">
            <p-skeleton styleClass="w-full h-1rem" />
          </td>
        </tr>
      }
    </ng-template>
    <ng-template #emptymessage>
      @if (loading) {
        <tr *ngFor="let _ of [1, 2, 3, 4, 5, 6, 7, 8]">
          <td *ngFor="let col of [1, 2, 3, 4, 5, 6, 7]">
            <p-skeleton styleClass="w-full h-1rem" />
          </td>
        </tr>
      } @else {
        <tr class="p-empty-row">
          <td colspan="7">No files found.</td>
        </tr>
      }
    </ng-template>
  </p-table>
</div>

<!-- Define buttons which will show in each of the rows of the table. -->
<ng-template #buttonTemplate let-file>
  <button
    pButton
    pRipple
    type="button"
    icon="pi pi-cloud-download"
    (click)="downloadFile($event, file)"
    [loading]="isDownloadingFile(file)"
    [disabled]="isDownloadingFile(file)"
    text
    rounded
    severity="info"
    pTooltip="Download"
    tooltipPosition="bottom"
  ></button>
  <button
    pButton
    pRipple
    type="button"
    icon="pi pi-trash"
    (click)="deleteFile($event, file)"
    [loading]="isStartingFileDeletion(file)"
    [disabled]="
      !canDeleteFile(file) ||
      isCommittingFile(file) ||
      isDeletingFile(file) ||
      isStartingFileDeletion(file)
    "
    text
    rounded
    severity="danger"
    [pTooltip]="
      !canDeleteFile(file)
        ? 'Files can only be deleted within seven days of upload'
        : isCommittingFile(file)
        ? 'Cannot delete while the file commit is in progress'
        : isDeletingFile(file)
          ? 'Deletion in progress'
          : 'Delete'
    "
    tooltipPosition="bottom"
  ></button>
  <button
    pButton
    pRipple
    type="button"
    icon="pi pi-save"
    (click)="saveFile($event, file)"
    [loading]="isCommittingFile(file)"
    [disabled]="
      isCommittingFile(file) || isDeletingFile(file) || isFileSaved(file)
    "
    text
    rounded
    severity="success"
    [pTooltip]="
      isFileSaved(file) ? 'Already saved to repayments' : 'Commit to Salesforce'
    "
    tooltipPosition="bottom"
  ></button>
  <span *ngIf="isCommittingFile(file)" class="commit-progress">
    {{ commitProgressPercent(file) }}%
  </span>
  <span *ngIf="isDeletingFile(file)" class="commit-progress">
    {{ deleteProgressPercent(file) }}%
  </span>
</ng-template>

<p-confirmDialog></p-confirmDialog>
